import React, { useState } from 'react';
import styled from 'styled-components';

const SearchContainer = styled.div`
    display: flex;
    justify-content: right;
    width: 100%;
`;

const SearchForm = styled.div`
    display: flex;
    width: 40%;
    max-width: 500px;
    border: 1px solid #ddd;
    border-radius: 4px;
    overflow: hidden;
    gap: 8px; /* Add spacing between child elements */
`;

const SearchSelect = styled.select`
    width: 80px;
    padding: 10px;
    border: none;
    border-right: 1px solid #ddd;
    background-color: #f5f6f6;
    color: #444;
    font-size: 14px;
    outline: none;
`;

const SearchInput = styled.input`
    width: 100px;
    flex-grow: 1;
    padding: 10px;
    border: none;
    font-size: 14px;
    outline: none;
    
    &::placeholder {
        color: #aaa;
    }
`;

const SearchButton = styled.button`
    width: 120px;
    padding: 10px 20px;
    background-color: #666;
    color: white;
    border: none;
    cursor: pointer;
    font-size: 14px;
    
    &:hover {
        background-color: #444;
    }
`;

const BoardSearch = ({ onSearch }) => {
    const [searchType, setSearchType] = useState('title');
    const [searchTerm, setSearchTerm] = useState('');

    const handleSubmit = (e) => {
        e.preventDefault();
        onSearch(searchType, searchTerm);
    };

    return (
        <SearchContainer>
        <SearchForm as="form" onSubmit={handleSubmit}>
            <SearchSelect 
            value={searchType} 
            onChange={(e) => setSearchType(e.target.value)}
            >
            <option value="title">제목</option>
            <option value="content">내용</option>
            <option value="author">글쓴이</option>
            </SearchSelect>
            <SearchInput
            type="text"
            placeholder="검색어를 입력하세요"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            />
            <SearchButton type="submit">검색</SearchButton>
        </SearchForm>
        </SearchContainer>
    );
};

export default BoardSearch;
